import ApiService from "@/core/services/api.service";
import i18nService from "@/core/services/i18n.service.js";
import SiteService from "@/core/services/site.service.js";

const state = {
  errors: null,
  collection: [],
};

const getters = {
  propertyCollection(state) {
    return state.collection;
  },

  getPropertyByID: (state) => (id) => {
    let item = state.collection.find((item) => item.id == id);
    if (!item) {
      item = { name: "" };
    }
    return item;
  },
};

const actions = {
  fetchProperty(context) {
    return new Promise((resolve) => {
      let appLocale = i18nService.getUserActiveLanguage();

      ApiService.get(
        "products/admin/" + SiteService.getActiveSiteId() + "/property"
      ).then(({ data }) => {
        // create localized fields
        let dataLocalized = data.map((item) => {
            let custom_fields = item.custom_fields;
            if (item.translations) {
                let translations = item.translations[appLocale];
                if (translations) {
                    Object.keys(translations).forEach((property) => {
                        item[property] = item.translations[appLocale][property];
                    });
                    item.translated = true;
                } 
                else  {
                    for (const [key, value] of Object.entries(
                        item.translations[Object.keys(item.translations)[0]]
                    )) {
                        console.log("key", key);
                        if ("attachments" != key && "custom_fields" != key) {
                            item[key] = value;
                        }
                    }
                }
            }

            item.custom_fields = custom_fields;

            return item;
        });

        context.commit("fetchProperty", dataLocalized);
        resolve();
      });
    }).catch((error) => {
      console.log("Error!: ", error);
    });
  },
};

const mutations = {
  fetchProperty(state, data) {
    state.collection = data;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
